var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full flex-c"},[_c('bar-loader',{attrs:{"color":"#9B1C1F"}}),_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }